"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAuxiliarCatalogItem = exports.updateAuxiliarCatalog = exports.toggleAuxiliarCatalogItem = exports.toggleAuxiliarCatalog = exports.listAuxiliarCatalogs = exports.listAuxiliarCatalogItems = exports.importCatalogItems = exports.getAuxiliarCatalog = exports.downloadImportCatalogItemsTemplate = exports.deleteAuxiliarCatalog = exports.createAuxiliarCatalogItem = exports.createAuxiliarCatalog = void 0;
var _API = require("./API");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var microservice = 'requisitions';
var getBaseApi = function getBaseApi(tenantId) {
  return "/tenants/".concat(tenantId, "/catalogs");
};
var getSingleApi = function getSingleApi(tenantId, id) {
  return "".concat(getBaseApi(tenantId), "/").concat(id);
};
var getItemApi = function getItemApi(tenantId, id) {
  return "".concat(getSingleApi(tenantId, id), "/items");
};
var getItemSingleApi = function getItemSingleApi(tenantId, catalogId, id) {
  return "".concat(getItemApi(tenantId, catalogId), "/").concat(id);
};
var getListParams = function getListParams(params) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    page: "".concat((_a = params.page) !== null && _a !== void 0 ? _a : 0),
    offset: "".concat((_b = params.offset) !== null && _b !== void 0 ? _b : 0),
    search: (_c = params.search) !== null && _c !== void 0 ? _c : '',
    externalIds: (_e = (_d = params.externalIds) === null || _d === void 0 ? void 0 : _d.join(',')) !== null && _e !== void 0 ? _e : '',
    status: (_f = params.status) !== null && _f !== void 0 ? _f : '',
    itemStatus: (_g = params.itemStatus) !== null && _g !== void 0 ? _g : '',
    includeItems: "".concat((_h = params.includeItems) !== null && _h !== void 0 ? _h : false)
  };
};
var getParams = function getParams(params) {
  var _a, _b;
  return {
    itemStatus: (_a = params.itemStatus) !== null && _a !== void 0 ? _a : '',
    includeItems: "".concat((_b = params.includeItems) !== null && _b !== void 0 ? _b : true)
  };
};
var getListItemParams = function getListItemParams(params) {
  var _a, _b, _c, _d, _e, _f, _g;
  return {
    page: "".concat((_a = params.page) !== null && _a !== void 0 ? _a : 0),
    offset: "".concat((_b = params.offset) !== null && _b !== void 0 ? _b : 0),
    search: (_c = params.search) !== null && _c !== void 0 ? _c : '',
    status: (_d = params.status) !== null && _d !== void 0 ? _d : '',
    id: (_e = params.id) !== null && _e !== void 0 ? _e : '',
    sku: (_f = params.sku) !== null && _f !== void 0 ? _f : '',
    description: (_g = params.description) !== null && _g !== void 0 ? _g : ''
  };
};
var getAuxiliarCatalogItemRequest = function getAuxiliarCatalogItemRequest(request) {
  return Object.assign(Object.assign({}, request), {
    currency_id: request.currency_id ? request.currency_id : null
  });
};
var listAuxiliarCatalogs = exports.listAuxiliarCatalogs = function listAuxiliarCatalogs(tenantId, params, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _API.callAPI)(getBaseApi(tenantId), {
            method: 'GET',
            microservice: microservice,
            query: getListParams(params),
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var createAuxiliarCatalog = exports.createAuxiliarCatalog = function createAuxiliarCatalog(tenantId, request, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _API.callAPI)(getBaseApi(tenantId), {
            method: 'POST',
            microservice: microservice,
            body: request,
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context2.abrupt("return", _context2.sent);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
var getAuxiliarCatalog = exports.getAuxiliarCatalog = function getAuxiliarCatalog(tenantId, id, params, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _API.callAPI)(getSingleApi(tenantId, id), {
            method: 'GET',
            microservice: microservice,
            query: getParams(params),
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context3.abrupt("return", _context3.sent);
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
var updateAuxiliarCatalog = exports.updateAuxiliarCatalog = function updateAuxiliarCatalog(tenantId, id, request, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _API.callAPI)(getSingleApi(tenantId, id), {
            method: 'PUT',
            microservice: microservice,
            body: request,
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context4.abrupt("return", _context4.sent);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};
var deleteAuxiliarCatalog = exports.deleteAuxiliarCatalog = function deleteAuxiliarCatalog(tenantId, id, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _API.callAPI)(getSingleApi(tenantId, id), {
            method: 'DELETE',
            microservice: microservice,
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context5.abrupt("return", _context5.sent);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};
var toggleAuxiliarCatalog = exports.toggleAuxiliarCatalog = function toggleAuxiliarCatalog(tenantId, id, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _API.callAPI)("".concat(getSingleApi(tenantId, id), "/toggle"), {
            method: 'PUT',
            microservice: microservice,
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context6.abrupt("return", _context6.sent);
        case 3:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
};
var listAuxiliarCatalogItems = exports.listAuxiliarCatalogItems = function listAuxiliarCatalogItems(tenantId, catalogId, params, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _API.callAPI)(getItemApi(tenantId, catalogId), {
            method: 'GET',
            microservice: microservice,
            query: getListItemParams(params),
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context7.abrupt("return", _context7.sent);
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
};
var createAuxiliarCatalogItem = exports.createAuxiliarCatalogItem = function createAuxiliarCatalogItem(tenantId, catalogId, request, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _API.callAPI)(getItemApi(tenantId, catalogId), {
            method: 'POST',
            microservice: microservice,
            body: getAuxiliarCatalogItemRequest(request),
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context8.abrupt("return", _context8.sent);
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
};
var updateAuxiliarCatalogItem = exports.updateAuxiliarCatalogItem = function updateAuxiliarCatalogItem(tenantId, catalogId, id, request, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _API.callAPI)(getItemSingleApi(tenantId, catalogId, id), {
            method: 'PUT',
            microservice: microservice,
            body: getAuxiliarCatalogItemRequest(request),
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context9.abrupt("return", _context9.sent);
        case 3:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
};
var toggleAuxiliarCatalogItem = exports.toggleAuxiliarCatalogItem = function toggleAuxiliarCatalogItem(tenantId, catalogId, id, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _API.callAPI)("".concat(getItemSingleApi(tenantId, catalogId, id), "/toggle"), {
            method: 'PUT',
            microservice: microservice,
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context10.abrupt("return", _context10.sent);
        case 3:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
};
var downloadImportCatalogItemsTemplate = exports.downloadImportCatalogItemsTemplate = function downloadImportCatalogItemsTemplate(tenantId, catalogId, connectorId, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _API.callAPI)("".concat(getItemApi(tenantId, catalogId), "/import"), {
            method: 'GET',
            microservice: microservice,
            query: {
              connectorId: connectorId
            },
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context11.abrupt("return", _context11.sent);
        case 3:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
};
var importCatalogItems = exports.importCatalogItems = function importCatalogItems(tenantId, catalogId, request, accessParams) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _API.callAPI)("".concat(getItemApi(tenantId, catalogId), "/import"), {
            method: 'PUT',
            microservice: microservice,
            body: request,
            access: accessParams === null || accessParams === void 0 ? void 0 : accessParams.access
          });
        case 2:
          return _context12.abrupt("return", _context12.sent);
        case 3:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
};